import { render, staticRenderFns } from "./IconChecklist.vue?vue&type=template&id=1077c063&"
import script from "./IconChecklist.vue?vue&type=script&lang=js&"
export * from "./IconChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports